import {
  EMPTY_VALUE_PLACEHOLDER,
} from '../email-tracking/constants';

const padDatePart = (value) => String(value).padStart(2, '0');

export const formatDateInputValue = (date) => {
  const year = date.getFullYear();
  const month = padDatePart(date.getMonth() + 1);
  const day = padDatePart(date.getDate());

  return `${year}-${month}-${day}`;
};

export const getCurrentMonthDateRange = () => {
  const now = new Date();
  const from = new Date(now.getFullYear(), now.getMonth(), 1);
  const to = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  return {
    from: formatDateInputValue(from),
    to: formatDateInputValue(to),
  };
};

export const formatDateTime = (value) => {
  if (!value) return EMPTY_VALUE_PLACEHOLDER;

  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    const day = padDatePart(date.getDate());
    const month = padDatePart(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = padDatePart(date.getHours());
    const minutes = padDatePart(date.getMinutes());

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  } catch {
    return value;
  }
};

export const getUserFullName = (user) => {
  if (!user) return '';

  return [user.firstname, user.lastname].filter(Boolean).join(' ');
};
